import { Button, ButtonGroup } from '@chakra-ui/button';
import { Heading } from '@chakra-ui/layout';
import React, { useEffect, useState } from 'react';
import Layout from '../../components/Layout';
import ToggleRow from '../../components/ToggleRow';
import SKCard from '../../components/UI/SKCard';
import { SIKKA_FAQS } from '@/data/faq';
import classes from './styles.module.scss';
import LinkIcon from '@/public/assets/icons/link.svg';
import { FAQS_PAGE } from '../../constants/route.const';
import { useToast } from '@chakra-ui/toast';
import { copyToClickBoard } from '../../utils';
import { PACKAGE } from '../../constants';
import { StorageService } from '../../service/Storage';
import { useRouter } from 'next/router';
const SUPPORTED_LANGS = ['en', 'hi'];

export default function Faq(props) {
  const [lang, setLang] = useState('en'); //en||hi
  const toast = useToast();
  const router = useRouter();
  const params = router.query;

  useEffect(() => {
    if (params.lang && SUPPORTED_LANGS.includes(params.lang)) {
      setLang(params.lang);
    }
    StorageService.setXPN(PACKAGE);
  }, []);

  const FAQS = SIKKA_FAQS;

  return (
    <Layout>
      <div className={classes.FaqPage}>
        {lang === 'hi' ? (
          <Heading as="h1">अक्सर पूछे जाने वाले प्रश्न</Heading>
        ) : (
          <Heading as="h1">Frequently asked questions</Heading>
        )}
        <div style={{ margin: '1rem 0rem' }}>
          <ButtonGroup variant="solid" spacing="0" size="xs" isAttached>
            <Button
              colorScheme={lang === 'en' ? 'brand' : 'gray'}
              onClick={() => setLang('en')}
            >
              English
            </Button>
            <Button
              colorScheme={lang === 'hi' ? 'brand' : 'gray'}
              onClick={() => setLang('hi')}
            >
              Hindi
            </Button>
          </ButtonGroup>
        </div>

        <div className={classes.FaqList}>
          {FAQS.map(d => (
            <SKCard className={classes.card} id={`${d.key}`} key={d.key}>
              <ToggleRow
                key={d.key}
                header={
                  <div className={classes.rowHeader}>
                    <LinkIcon
                      className={classes.linkIcon}
                      onClick={() => {
                        const FAQ_LINK = `${window.location.origin}${FAQS_PAGE}?lang=${lang}#${d.key}`;

                        router.replace(`${FAQS_PAGE}#${d.key}`);

                        if (copyToClickBoard(FAQ_LINK)) {
                          toast({ title: 'Link copied!', key: 'faq-link' });
                        }
                      }}
                    />
                    {d[lang].title}
                  </div>
                }
                body={d[lang].desc}
                defaultOpen={`#${d.key}` === `#${router.asPath.split('#')[1]}`}
              />
            </SKCard>
          ))}
        </div>
      </div>
    </Layout>
  );
}
